import { useMemo } from "react";
import useApi from "../useApi";

const BASE = "/audit/logs";

/**
 * Audit logs (GET /api/audit/logs).
 * Response shape: { success, data: { meta: { pagination }, data: [logs] } }
 */
export const useAuditLogs = (params = {}) => {
  const queryParams = useMemo(() => {
    const q = {};
    if (params.page) q.page = params.page;
    if (params.limit) q.limit = params.limit;
    if (params.action) q.action = params.action;
    if (params.entity) q.entity = params.entity;
    if (params.userId) q.userId = params.userId;
    if (params.search) q.search = params.search;
    if (params.dateFrom) q.dateFrom = params.dateFrom;
    if (params.dateTo) q.dateTo = params.dateTo;
    return q;
  }, [
    params.page,
    params.limit,
    params.action,
    params.entity,
    params.userId,
    params.search,
    params.dateFrom,
    params.dateTo,
  ]);

  const api = useApi(BASE, {
    method: "GET",
    params: queryParams,
    immediate: true,
    errorMessage: "Failed to fetch audit logs",
    transformResponse: (res) => res?.data ?? { meta: {}, data: [] },
  });

  const refetch = async () => {
    try {
      await api.execute();
      return { success: true };
    } catch (err) {
      return {
        success: false,
        message: err.response?.data?.message || "Failed to fetch audit logs",
      };
    }
  };

  return {
    data: api.data?.data ?? [],
    pagination: api.data?.meta?.pagination ?? {},
    loading: api.loading,
    error: api.error,
    refetch,
  };
};

export const useAuditActions = () => {
  const api = useApi(`${BASE}/actions`, {
    method: "GET",
    immediate: true,
    errorMessage: "Failed to fetch audit actions",
    transformResponse: (res) => res?.data?.actions ?? [],
  });
  return { data: api.data ?? [], loading: api.loading, error: api.error };
};

export const useAuditEntities = () => {
  const api = useApi(`${BASE}/entities`, {
    method: "GET",
    immediate: true,
    errorMessage: "Failed to fetch audit entities",
    transformResponse: (res) => res?.data?.entities ?? [],
  });
  return { data: api.data ?? [], loading: api.loading, error: api.error };
};
